/**
 * Helper functions for asset management
 * These functions centralize asset path management and make it easier to change paths for different environments
 */

/**
 * Get the correct path for assets in public folder
 * Use this for assets referenced in HTML, CSS, or JSON files
 * 
 * @param {string} filename - The filename of the asset
 * @returns {string} The complete path to the asset
 */
export const getAssetPath = (filename) => {
  // Check if the filename already includes a path or is a URL
  if (filename.startsWith('/') || filename.startsWith('http')) {
    return filename;
  }
  
  // For Parcel bundler, we need to use relative paths from the current file
  return `/public/${filename}`;
};

/**
 * Get the correct URL for assets in public folder
 * Use this for assets referenced in src attributes in JSX
 * 
 * @param {string} filename - The filename of the asset
 * @returns {string} The complete URL to the asset
 */
export const getAssetUrl = (filename) => {
  // Check if the filename already includes a path or is a URL
  if (filename.startsWith('/') || filename.startsWith('http')) {
    return filename;
  }
  
  // For video and image sources in JSX
  return `/${filename}`; // Remove /public prefix
};
